module.exports = "https://cdn2-fs.clearscore.com/flux/images/f4e13711ea33c76bc7e9ad03b33574ab.png";